/** Clear only the revoked session before an old persistor can flush it again. */
export function clearRevokedSession(expectedToken, getState, logout) {
  if (!expectedToken) return false;
  const user = getState().user;
  if (user.token !== expectedToken) return false;
  logout(user.rememberMe);
  return true;
}
